import { __rest } from 'tslib';

const extractLayoutProps = (props) => {
    const { width, height } = props, rest = __rest(props, ["width", "height"]);
    return {
        $width: width,
        $height: height,
        rest,
    };
};

export { extractLayoutProps };
//# sourceMappingURL=extractLayoutProps.js.map
